import css from './Layout.module.scss';

const layoutTypeClassMap = {
  default: css.layout,
  compressed: css.compressed
};

const Layout = props => (
  <div
    data-e2e={props['data-e2e'] ? props['data-e2e'] : 'layout'}
    className={layoutTypeClassMap[props.layoutType || 'default']}
  >
    {props.children}
  </div>
);

export default Layout;
